// calculators/average-daily-balance/src/index.ts
// Entry point. Bundled to /calculators/average-daily-balance/bundle.js.

import { attachCalculator } from "./calculator";

function start(): void {
  attachCalculator();
}

const w = window as unknown as { i18nReady?: Promise<unknown> };

function whenReady(): void {
  if (w.i18nReady && typeof w.i18nReady.then === "function") {
    let attached = false;
    const safeStart = (): void => {
      if (attached) return;
      attached = true;
      start();
    };
    w.i18nReady.then(safeStart).catch(safeStart);
    setTimeout(safeStart, 1500);
  } else {
    start();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", whenReady);
} else {
  whenReady();
}
